import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { SpringSystem, MathUtil } from 'rebound';


export default class SpringScrollbars extends Component {

    constructor(props, ...rest) {
        super(props, ...rest);
        this.handleSpringUpdate = this.handleSpringUpdate.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.state = {

            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        };
    }



    componentDidMount() {
        this.springSystem = new SpringSystem();
        this.spring = this.springSystem.createSpring();
        this.spring.springSpeed = 0.06;
        this.spring._springConfig = {friction : 150, tension:502}
        this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });

        window.addEventListener("resize", this.handleResize, false);

        this.setState({
              viewport: {
                  width: document.documentElement.clientWidth,
                  height: document.documentElement.clientHeight
              }
          });
    }




    componentWillUnmount() {
        this.springSystem.deregisterSpring(this.spring);
        this.springSystem.removeAllListeners();
        this.springSystem = undefined;
        this.spring.destroy();
        this.spring = undefined;
    }

    handleResize(e) {
      this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });
    }

    getScrollTop() {
        return this.refs.scrollbars.getScrollTop();
    }

    getScrollHeight() {
        return this.refs.scrollbars.getScrollHeight();
    }

    getHeight() {
        return this.refs.scrollbars.getHeight();
    }

    getValues() {
      ////console.log(JSON.stringify(this.refs.scrollbars.getValues()));//scrollTop is interesting for saving the scroll position
        return this.refs.scrollbars.getValues();
    }

    scrollToBottom() {
        return this.refs.scrollbars.scrollToBottom();
    }


    scrollTop(top) {
        const { scrollbars } = this.refs;
        const scrollTop = scrollbars.getScrollTop();
        const scrollHeight = scrollbars.getScrollHeight();
        //const val = MathUtil.mapValueInRange(top, 0, scrollHeight, scrollHeight * 0.01, scrollHeight * 0.99);
        const val = MathUtil.mapValueInRange(top, 0, scrollHeight, 0, scrollHeight);
        this.spring.springSpeed = 0.06;
        this.spring._springConfig = {friction : 50, tension:502}
        this.spring.setCurrentValue(scrollTop).setAtRest();
        this.spring.setEndValue(val);
    }

    handleSpringUpdate(spring) {
        const { scrollbars } = this.refs;
        const val = spring.getCurrentValue();
        scrollbars.scrollTop(val);

    }

    render() {

      const wW = this.props['data-wW'];
      const ttl = this.props['data-title'];
        return (
            <Scrollbars
              className="sclB"
              style={{  width:100+'%' }}
                {...this.props}
              /*  onScrollFrame={values => {

              }} */
                renderTrackVertical={props => <div {...props} style={{ position:'absolute', width: 6, right: 0, bottom: 0, top: 0, borderRadius: 0 }} className="track-vertical"/>}
                renderThumbVertical={props => <div ref="handleDrag" className="handlebar" {...props} style={
                  { 'cursor':'pointer',borderRadius:0,backgroundColor:'black',marginLeft:wW*-1 ,width:wW+6,top:100+'px' }} className="thumb-vertical">
                  <div className="collectionTtl">{ttl}</div>
                </div>
                }
                thumbMinSize={40}
                thumbSize={40}
                ref="scrollbars"/>



        );
    }
}



// WEBPACK FOOTER //
// ./src/js/components/SpringScrollbars.js